<template>
  <div>
    <el-row class="m-b15 flex-ac flex p-lr20">
      <el-col :span="10" class="flex-ac flex">
        <span class="f-14" style="display: inline-block;width: 90px;">查询条件：</span>
        <el-input
          size="medium"
          v-model="params.orderNoOrBuyerOrgName"
          placeholder="申请编号、买家客户"
        ></el-input>
      </el-col>
      <el-col :span="1"></el-col>
      <el-col :span="12">
        <span>申请时间：</span>
        <el-date-picker
          v-model="params.dateRange"
          type="daterange"
          size="medium"
          range-separator="-"
          value-format="timestamp"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-col>
    </el-row>
    <div class="p-lr20 m-b15">
      <el-button type="primary" size="medium" @click="loadData">查询</el-button>
      <el-button type="primary" size="medium" @click="reset">重置</el-button>
    </div>

    <el-table :data="dataList">
      <el-table-column label="申请单编号" prop="invoiceApplyCode" align="center" width="250">
        <template v-slot="{ row }">
          <el-button type="text" @click="viewDetail(row.id)">{{ row.invoiceApplyCode }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="提交日期" prop="gmtCreated" align="center" width="100">
        <template v-slot="{ row }">
          <div>{{ row.gmtCreated | formatTime('{y}-{M}-{d}') }}</div>
        </template>
      </el-table-column>
      <el-table-column label="商家抬头" prop="sellerOrgName" align="center"></el-table-column>
      <el-table-column label="买方抬头" prop="buyerOrgName" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template v-slot="{ row }">
          <el-button type="text" @click="viewDetail(row.id)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      class="page"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="params.pageNo"
      :page-size="params.pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
  </div>
</template>

<script>
const DEFAULT_PARAM = {
  pageNo: 1,
  pageSize: 10,
  status: 2,
  orderNoOrBuyerOrgName: '',
  startApplyDate: 0,
  endApplyDate: 0,
  dateRange: []
}

export default {
  data() {
    return {
      params: { ...DEFAULT_PARAM },
      total: 0,
      dataList: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      let param = {
        request: {
          status: 2,
          pageSize: this.params.pageSize,
          pageNo: this.params.pageNo
        }
      }
      if (this.params.dateRange.length > 0) {
        param.request.startApplyDate = this.params.dateRange[0]
        param.request.endApplyDate = this.params.dateRange[1] + (60 * 60 * 24 - 1) * 1000
      }

      if (this.params.orderNoOrBuyerOrgName) {
        param.request.orderNoOrBuyerOrgName = this.params.orderNoOrBuyerOrgName
      }

      let { success, data } = await this.$post('invoice.seller.queryInvoiceApply', param)
      if (success) {
        let { totalNum: total, sellerInvoiceApplyVOList: dataList = [] } = data[0]
        this.total = total
        this.dataList = dataList.map(i => ({
          sellerOrgName: i.sellerOrgName,
          buyerOrgName: i.buyerOrgName,
          invoiceApplyCode: i.invoiceApplyCode,
          gmtCreated: i.gmtCreated,
          id: i.id
        }))
      }
    },
    viewDetail(id) {
      this.$router.push({ path: 'invoice-detail/' + id })
    },
    reset() {
      this.params = { ...DEFAULT_PARAM }
      this.loadData()
    },
    handleSizeChange(size) {
      this.params.pageSize = size
      this.loadData()
    },
    handleCurrentChange(pageNo) {
      this.params.pageNo = pageNo
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  text-align: right;
  margin-top: 20px;
}
</style>
